/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';
// material
import { Container, Button, Card, Autocomplete, TextField, Stack, Typography, Box } from '@mui/material';
import PermissionGuard from 'guards/PermissionGuard';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Page from 'components/Page';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import { PATH_SPEMPLOYEE } from 'routes/paths';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Icon } from '@iconify/react';
import Scrollbar from 'components/Scrollbar';
import AnalyticsEachNumberData from 'components/analytics/AnalyticsEachNumberData';
import { useDispatch, useSelector } from 'react-redux';
import useIsMountedRef from 'hooks/useIsMountedRef';
import _ from 'lodash';
import useAuth from 'hooks/useAuth';
import { getAllSPEmployeeApi } from 'redux/spEmployee/spEmployeeApi';
import { getAllAdminUsersApi } from 'redux/user/userApi';
import EmployeeTable from './components/EmployeeTable';

export default function EmployeeList() {
  const isMounted = useIsMountedRef();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const { isSPEmployeeLoading, spEmployeeList = [] } = useSelector(({ spEmployeeReducer }) => spEmployeeReducer);
  const { user = {} } = useAuth();
  const marginValue = isDesktop ? '8px 4px' : '8px 0px';
  const { adminUsersList, selectedUser = {} } = useSelector(({ adminReducer }) => adminReducer);
  const [selectedOem, selectOem] = useState('');
  const [selectedCompany, selectCompany] = useState('');

  useEffect(() => {
    if (isMounted?.current) {
      const params = {
        userName: user?.userName
      };
      dispatch(getAllSPEmployeeApi(params));
      dispatch(
        getAllAdminUsersApi({
          roleBase: 'OEM'
        })
      );
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedOem)) {
      const params = {
        userName: selectedOem
      };
      dispatch(getAllSPEmployeeApi(params));
    }
  }, [selectedOem]);

  return (
    <>
      {user?.accessList?.USER?.READ && (
        <Page title="User | Serviceplug">
          <Container maxWidth="xl" sx={{ mt: '30px', px: '8px !important' }}>
            <HeaderBreadcrumbs
              heading="User List"
              links={[{ name: 'User', href: PATH_SPEMPLOYEE.root }, { name: 'User List' }]}
              action={
                <>
                  {user?.role === 'ADMIN' && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'colummn', sm: 'column', md: 'row', lg: 'row', xl: 'row' },
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '40vw'
                      }}
                    >
                      <Autocomplete
                        options={adminUsersList}
                        filterSelectedOptions
                        value={selectedOem}
                        isOptionEqualToValue={(option, value) => option?._id === value?._id}
                        onChange={(event, value) => {
                          selectOem(value.userName);
                          selectCompany(value.businessName);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth label="Select Partner *" sx={{ mb: 2 }} />
                        )}
                        sx={{ marginTop: '24px', marginRight: '12px', width: '100vw' }}
                        renderOption={(props, option) => (
                          <li {...props}>
                            <Stack direction="row" alignItems="center">
                              <Typography>{option.userName}</Typography>
                              <Typography> ({option.businessName})</Typography>
                            </Stack>
                          </li>
                        )}
                      />
                      {user?.accessList?.USER?.CREATE && (
                        <Button
                          variant="contained"
                          component={RouterLink}
                          to={PATH_SPEMPLOYEE.create}
                          startIcon={<Icon icon={plusFill} />}
                          sx={{ width: '40vw' }}
                        >
                          New Employee
                        </Button>
                      )}
                    </Box>
                  )}
                  {user?.role !== 'ADMIN' && user?.accessList?.USER?.CREATE && (
                    <Button
                      variant="contained"
                      component={RouterLink}
                      to={PATH_SPEMPLOYEE.create}
                      startIcon={<Icon icon={plusFill} />}
                    >
                      New Employee
                    </Button>
                  )}
                </>
              }
              sx={{ mb: 0 }}
            />
            <AnalyticsEachNumberData
              title={`Total Employees  ${!_.isEmpty(selectedCompany) ? `( ${selectedCompany})` : ''}`}
              number={spEmployeeList?.length}
              sx={{ backgroundColor: '#74CAFF', margin: marginValue }}
            />
            <Card>
              <Scrollbar>
                <EmployeeTable spEmployeeList={spEmployeeList} isSPEmployeeLoading={isSPEmployeeLoading} user={user} />
              </Scrollbar>
            </Card>
          </Container>
        </Page>
      )}
      {!user?.accessList?.USER?.READ && <PermissionGuard />}
    </>
  );
}
